import React from 'react';
import { LoggedInUser } from '../../types/general.types';

const GlobalContext = React.createContext<LoggedInUser | null>(null);

export default GlobalContext;
